import React from "react";
import { Card, Flex, Typography } from "antd";
import { Spinner, radius } from "@libertify/ui";
import { analyticsTheme } from "./analyticsTheme";

const { Text } = Typography;

export type StatCardProps = {
  title: string;
  /** Pre-formatted value — a number or a string like "67%". */
  value: number | string;
  description: string;
  loading?: boolean;
};

/**
 * Generic analytics KPI card: colored accent bar, title, tinted icon badge,
 * a large value and a description line. The `color` prop picks the accent;
 * "green" resolves to the org's theme primary color.
 */
export const StatCard: React.FC<StatCardProps> = ({
  title,
  value,
  description,
  loading,
}) => {
  return (
    <Card
      styles={{ body: { padding: "20px 24px" } }}
      style={{
        width: "100%",
        height: "100%",
        borderColor: analyticsTheme.cardBorder,
        borderRadius: radius.box,
      }}
    >
      <Text
        type="secondary"
        style={{
          fontSize: 11,
          fontWeight: 600,
          letterSpacing: 0.5,
          textTransform: "uppercase",
        }}
      >
        {title}
      </Text>

      <Flex align="center" style={{ minHeight: 40, marginTop: 12 }}>
        {loading ? (
          <Spinner size="md" variant="primary" />
        ) : (
          <Text
            style={{
              fontSize: 36,
              lineHeight: 1.1,
            }}
          >
            {value}
          </Text>
        )}
      </Flex>

      <Text
        type="secondary"
        style={{
          display: "block",
          fontSize: 14,
        }}
      >
        {description}
      </Text>
    </Card>
  );
};
